import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="#41537a"
					title={"Koombana Physiotherapy"}
					image={require('./video.jpg')}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">A fresh online look for a well establish local business.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/koombana-physiotherapy.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi built a fresh professional looking website making sure it was still easy to use by the business's varied customer base.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Website <a href="https://www.koombanaphysio.com.au" target="_blank">www.koombanaphysio.com.au</a></li>
									<li>Custom designed for visual impact</li>
									<li>Responsive design to work on all devices</li>
									<li>Animated elements for smooth flow</li>
									<li>Email newsletter design</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Nites Electrical Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Nites Electrical Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Nites Electrical Feature" width="100%" />
								<img src={require('./example-3.jpg')} alt="Nites Electrical Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/Koombana/index.js